import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import classnames from 'classnames2';
import React from 'react';
import { Button } from '../Button';
import { Header } from '../Header';
import { Icon } from '../Icon';
import styles from './Sidebar.scss';
export var Sidebar = /*#__PURE__*/function (_React$Component) {
  _inherits(Sidebar, _React$Component);

  var _super = _createSuper(Sidebar);

  function Sidebar(props) {
    var _this;

    _classCallCheck(this, Sidebar);

    _this = _super.call(this, props);

    _this.onExpandClick = function () {
      if (_this.props.onExpand) {
        _this.props.onExpand();
      }

      _this.setState({
        isCollapsed: false
      }, function () {
        _this.expandedRef.current.focus();
      });
    };

    _this.onCollapseClick = function () {
      if (_this.props.onCollapse) {
        _this.props.onCollapse();
      }

      _this.setState({
        isCollapsed: true
      }, function () {
        _this.collapsedRef.current.focus();
      });
    };

    _this.expandedRef = React.createRef();
    _this.collapsedRef = React.createRef();
    _this.state = {
      isCollapsed: props.isCollapsed === undefined ? true : props.isCollapsed
    };
    return _this;
  }

  _createClass(Sidebar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$as = _this$props.as,
          as = _this$props$as === void 0 ? 'aside' : _this$props$as,
          _this$props$headerAs = _this$props.headerAs,
          headerAs = _this$props$headerAs === void 0 ? 'h2' : _this$props$headerAs,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          expandedClassName = _this$props.expandedClassName,
          collapsedClassName = _this$props.collapsedClassName,
          dataTest = _this$props.dataTest;
      var contentHeaderInner = React.createElement(React.Fragment, null, React.createElement("div", {
        className: styles.capitalContentTitle
      }, title), React.createElement(Button, {
        "aria-label": "Hide ".concat(title),
        size: "small",
        onClick: this.onCollapseClick,
        className: styles.capitalAlignRight
      }, React.createElement(Icon, {
        icon: "arrow-chevron-left"
      })));
      var contentHeader = headerAs === 'span' ? React.createElement("span", {
        className: styles.capitalContentHeader
      }, contentHeaderInner) : React.createElement(Header, {
        variant: headerAs,
        className: styles.capitalContentHeader
      }, contentHeaderInner);
      var contentComponentClassName = classnames(styles.capitalContentContainer, expandedClassName);
      var contentComponent = as === 'div' ? React.createElement("div", {
        "aria-expanded": true,
        className: contentComponentClassName,
        "data-test": dataTest,
        ref: this.expandedRef
      }, contentHeader, children) : React.createElement("aside", {
        "aria-expanded": true,
        className: contentComponentClassName,
        "data-test": dataTest,
        ref: this.expandedRef
      }, contentHeader, children);
      var headerComponentClassName = classnames(styles.capitalHeaderContainer, collapsedClassName);
      return React.createElement(React.Fragment, null, this.state.isCollapsed && React.createElement("button", {
        "aria-expanded": false,
        "aria-label": "Expand ".concat(title),
        className: headerComponentClassName,
        "data-test": dataTest,
        onClick: this.onExpandClick,
        ref: this.collapsedRef
      }, React.createElement(Icon, {
        icon: "arrow-chevron-right",
        className: styles.capitalIcon
      }), React.createElement("div", {
        className: styles.capitalTitle
      }, title)), !this.state.isCollapsed && contentComponent);
    }
  }]);

  return Sidebar;
}(React.Component);